export const BASE_FARE = "Base Fare";
export const TAXES_AND_FEES = "Taxes & Fees";
export const SEAT_SELECTION = "Seat Selection";
export const DISRUPTION_PROTECTION = "Flight disruption assistance";
export const CANCEL_FOR_ANY_REASON = "Cancel for any reason";
export const TRIP_TOTAL = "Total";
